module.exports = __webpack_public_path__ + "img/lock.524db919.svg";